module.exports = __webpack_public_path__ + "img/_t20_JYKebP.e5e6ac35.png";